import React from 'react';
import Box from '../../../common/ui/lib/BaseBox';
import SummaryWorkflow from '../../summary';
import TableJobs from '../../../common/ui/components/TableJobs';
import { WorkflowName } from '../../common/types';
import useSummary from '../../../common/services/summary/use';
import { constructUrlForWorkflowPage } from '../../../common/helpers';
import { useStyles } from './styles';
const WorkflowValidation = ({ validation, summaryWhitelist, classes }) => {
    const ownClasses = useStyles();
    const { selectedRun, summary, handleRunChange, handleWorkflowRerun } = useSummary(validation, summaryWhitelist);
    return (React.createElement(Box, { classes: { root: classes?.root, header: ownClasses.boxHeader, content: ownClasses.boxContent }, header: React.createElement(SummaryWorkflow, { title: `Workflow: ${WorkflowName.Validation}`, summary: summary, url: constructUrlForWorkflowPage(validation[selectedRun].symbol), onRunChange: handleRunChange, onRerun: () => handleWorkflowRerun(WorkflowName.Validation) }) },
        React.createElement(TableJobs, { jobs: validation[selectedRun].jobs })));
};
export default WorkflowValidation;
